import React from "react";
import { AddToCard } from "./AddToCard";
import { Title } from "./Title";
import { ProductDescription } from "./ProductDescription";
import { GabriellePerfume } from "./ProductDetails";
import { Price } from "./Price";
import "./Card.css";

const ProductCard = () => {
  return (
    <div className="product-card">
      <Title />
      <GabriellePerfume />
      <ProductDescription />
      <Price />
      <AddToCard />
    </div>
  );
};
export default ProductCard;
